module.exports = __webpack_public_path__ + "img/user-check.15bdfe2a.svg";